import script from "./SearchDisableExpired.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchDisableExpired.vue?vue&type=script&lang=ts&setup=true"

import "./SearchDisableExpired.vue?vue&type=style&index=0&id=b7522fd4&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7522fd4"]])

export default __exports__